var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegotiation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1626_1414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52942 11.6451C5.00752 12.5794 3.20508 15.0086 3.20508 17.8513C3.20508 20.9854 5.39624 23.6176 8.32707 24.297V26.5038C8.32707 27.0836 8.66277 27.6112 9.18805 27.8568C9.38985 27.9514 9.60614 27.9976 9.82091 27.9976C10.1646 27.9976 10.5049 27.8793 10.7788 27.6505L14.59 24.4671H20.9812C23.5668 24.4671 25.8094 22.9752 26.897 20.808H19.1093C13.4899 20.8077 8.76843 16.8915 7.52942 11.6451Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2685 0H19.1098C14.1969 0 10.2002 3.99704 10.2002 8.90999C10.2002 13.8229 14.1969 17.8196 19.1098 17.8196H28.6061L34.311 22.5845C34.5849 22.8134 34.9252 22.9317 35.2689 22.9317C35.4836 22.9317 35.6995 22.8855 35.9017 22.7909C36.427 22.5452 36.7627 22.0177 36.7627 21.4378V17.6945C40.9669 16.9819 44.1785 13.3141 44.1785 8.90999C44.1785 3.99704 40.1814 0 35.2685 0Z",
    fill: "#AD186A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7196 43.6405C16.7709 42.0394 15.3812 40.7756 13.76 39.965C15.6223 37.7712 15.5201 34.4688 13.4498 32.3989C11.2705 30.2192 7.72435 30.2196 5.54502 32.3989C4.48911 33.4545 3.90775 34.8583 3.90775 36.3513C3.90775 37.6903 4.37658 38.9568 5.2345 39.9654C3.61364 40.7756 2.22394 42.0398 1.27523 43.6405C0.497793 44.9516 0.485967 46.5282 1.24318 47.8576C2.00765 49.1989 3.38399 49.9999 4.92513 49.9999H14.0697C15.6109 49.9999 16.9876 49.1989 17.7517 47.8576C18.5089 46.5282 18.4971 44.9516 17.7196 43.6405Z",
    fill: "#157B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6599 42.4881C47.3884 40.3431 45.4773 38.6863 43.2556 37.7029C44.5282 36.4299 45.2293 34.7377 45.2293 32.9376C45.2293 31.1374 44.5282 29.4448 43.2552 28.1715C40.6269 25.5436 36.351 25.5439 33.7231 28.1715C32.4501 29.4448 31.7489 31.137 31.7489 32.9376C31.7489 34.7377 32.4501 36.4303 33.7227 37.7029C31.501 38.6863 29.5898 40.3431 28.3184 42.4881C27.4006 44.0361 27.3868 45.8976 28.2814 47.4678C29.1847 49.0535 30.8113 50 32.6324 50H44.3458C46.167 50 47.7936 49.0535 48.6973 47.4678C49.5914 45.8976 49.5777 44.0361 48.6599 42.4881Z",
    fill: "#AD186A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1626_1414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegotiation);
export default __webpack_public_path__ + "static/media/negotiation.cb05ae33b5b901dd0cbb71afd1a7177b.svg";
export { ForwardRef as ReactComponent };